import React, { useState, useEffect } from 'react';
import Panel from 'Components/Panel/Panel';
import ExecuteAxios from 'Components/ExecuteAxios/ExecuteAxios';
import ApplyAttributes from 'Components/ApplyAttributes/ApplyAttributes';
import PanelListDefault from 'Components/PanelListDefault/PanelListDefault';
import AutomaticallyListedAttributes from 'Components/AutomaticallyListedAttributes/AutomaticallyListedAttributes';
import ResetVariables from 'Components/ResetVariables/ResetVariables';
import RemoveIdsNotFound from 'Components/RemoveIdsNotFound/RemoveIdsNotFound';
import LoadingIndicator from 'Components/LoadingIndicator/LoadingIndicator';

const SalaryItem = ({
    registrationIdsSelected,
    isActiveFilter,
}) => {
    const [idSalaryItem, setIdSalaryItem] = useState(null);
    const [dsItem, setDsItem] = useState(null);
    const [sequenceId, setSequenceId] = useState(null);
    const [isActive, setIsActive] = useState('S');
    const [username, setUsername] = useState(null);
    const [updateDate, setUpdateDate] = useState(null);
    const [dsItemChanged, setDsItemChanged] = useState(null);

    const [inserting, setInserting] = useState(false);
    const [updating, setUpdating] = useState(false);
    const [salaryItemSelected, setSalaryItemSelected] = useState([]);

    const [recordsSalaryItems, setRecordsSalaryItems] = useState(null);
    const [salaryItemAttributesDetail, setSalaryItemAttributesDetail] = useState([]);

    const readOnlyAttributes = !(inserting || updating);

    const attributeList = [
        { name: "id", value: idSalaryItem, setter: setIdSalaryItem },
        { name: "dsItem", value: dsItem, setter: setDsItem },
        { name: "idSequence", value: sequenceId, setter: setSequenceId },
        {
            name: "isActive",
            value: isActive,
            setter: setIsActive,
            resetValue: 'S',
            checks: [
                { field: 'isActive', condition: 'VALUE_EQUALS', arrayValue: ['S'] }
            ]
        },
        { name: "username", value: username, setter: setUsername },
        { name: "dtUpdate", value: updateDate, setter: setUpdateDate },
        { name: "dsItemChanged", value: dsItemChanged, setter: setDsItemChanged }
    ];

    useEffect(() => {
        setInserting(false)
        setUpdating(false)
        setSalaryItemSelected([])
    }, [isActiveFilter]);

    useEffect(() => {
        getSalaryItemsRecords()
    }, [inserting, updating, isActiveFilter, registrationIdsSelected]);

    const setAttributesPanel = async (salaryItemSelected) => {
        const parameters = { id: salaryItemSelected }
        const salaryItems = await ExecuteAxios.api('get', `/item-salary/item-salary-by-id/`, { params: parameters })
        setSalaryItemAttributesDetail(salaryItems)
        if (salaryItems) {
            ApplyAttributes.applyAttributes(salaryItems, attributeList)
        }

        if (!salaryItemSelected || salaryItemSelected.length === 0) {
            ResetVariables.resetVariables(attributeList);
        }
    };

    useEffect(() => {
        if (salaryItemSelected && salaryItemSelected.length === 1) {
            setAttributesPanel(salaryItemSelected[0]);
        } else {
            setAttributesPanel(null)
        }
    }, [salaryItemSelected]);

    const userControlPanelStyle = {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '83%',
        zIndex: '0'
    };

    async function getSalaryItemsRecords() {
        const parameter = {
            isActive: isActiveFilter
        }
        const itemsSalary = await ExecuteAxios.api('get', `/item-salary/list-item-salary/`, { params: parameter })
        setRecordsSalaryItems(itemsSalary);
        RemoveIdsNotFound.remove(itemsSalary, setSalaryItemSelected, salaryItemSelected)
    }

    const getSalaryItemsPanelListOrDetail = () => {
        if (!inserting && !updating) {
            return (
                <LoadingIndicator loaded={recordsSalaryItems}>
                    <PanelListDefault
                        onUpdateIdSelected={setSalaryItemSelected}
                        idsSelected={salaryItemSelected}
                        data={recordsSalaryItems}
                        attributeList={attributeList}
                    />
                </LoadingIndicator>
            )
        } else {
            return (
                <AutomaticallyListedAttributes
                    list={salaryItemAttributesDetail}
                    attributeList={attributeList}
                    readOnlyAttributes={readOnlyAttributes}
                />
            )
        }
    }

    async function putSalaryItem() {
        if (salaryItemSelected && salaryItemSelected.length === 1) {
            return await ExecuteAxios.api('put', `/item-salary/`, {
                id: idSalaryItem,
                dsItem: dsItem,
                sequenceId: sequenceId,
                isActive: isActive,
                dsItemChanged: dsItemChanged
            });
        }
    }

    return (
        <Panel
            titlePage='Itens do Salário'
            style={userControlPanelStyle}
            setUpdating={setUpdating}
            setInserting={setInserting}
            inserting={inserting}
            updating={updating}
            enableEdit={true}
            canEdit={(salaryItemSelected && salaryItemSelected.length === 1)}
            putFunction={putSalaryItem}
            canViewCRUD={true}
            readOnly={false}
            recordsSelected={salaryItemSelected}
            viewOnlyOneRecordCRUD={true}
            resetVariables={() => { ResetVariables.resetVariables(attributeList) }}
            dataListedAttributes={salaryItemAttributesDetail}
            attributeList={attributeList}
        >
            {getSalaryItemsPanelListOrDetail()}
        </Panel>
    );
};

export default SalaryItem;


